import { useQuery } from 'react-query';
import { useContext } from 'react';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AppContext } from 'views/App/context';

import type { AccreditationBody } from '../../../_types/awb';

export default function useAccreditingBody(
  orgId?: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const { isFeatureEnabled } = useContext(AppContext);
  const useRUIData = isFeatureEnabled('awbRUIData') || isFeatureEnabled('awbPremiumDemo');
  const url = useRUIData
    ? `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${id}`
    : `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/accreditation-bodies/${id}`;

  return useQuery<AccreditationBody, Error>(
    ['accrediting_body', orgId, id],
    async () => {
      const data = await fetcher({
        method: 'get',
        url,
      });
      return data;
    },
    {
      ...options,
      enabled: !!id,
    }
  );
}
